module.exports = __webpack_public_path__ + "img/cuoti_normal.fa3fc773.png";